import { IPerson, Person } from './person';
import { Product } from './product';
import { tryParseDate } from '@shared/functions/try-parse-date';
import { Boat, IBoat } from '@shared/models/boat';

export interface KeyRaw {
    id: number;
    keyName: string;
    keyType: string;
    note: string;
    product: any;
    rentingList: any[];
    keyId: string;
    isUnique: boolean;
    hasDualUse?: boolean | number;
}

export interface KeyAssignmentRaw extends KeyRaw {
    key: KeyRaw;
    person: IPerson;
    boat?: IBoat;
    id: number;
    keyNumber: string;
    keyFeePayed: boolean;
    keyFeePayedOn: string;
    keyFeePayedBack: boolean;
    keyFeePayedBackOn: string;
    fromDate: string;
    toDate: string;
    note: string;
}

export class Key {
    id: number;
    keyName: string;
    keyType: string;
    note: string;
    rentingList: KeyAssignment[];
    product: Product;
    keyId: string;
    isUnique: boolean;
    hasDualUse?: boolean;

    constructor(key = {} as KeyRaw) {
        this.id = key.id || null;
        this.keyName = key.keyName || '';
        this.keyType = key.keyType || '';
        this.note = key.note || '';
        this.rentingList = (key.rentingList || []).map(keyAssignment => new KeyAssignment(keyAssignment));
        this.product = key.product ? new Product(key.product) : null;
        this.keyId = key.keyId || '';
        this.isUnique = key.isUnique || false;
        this.hasDualUse = key.hasDualUse == null ? undefined : !!key.hasDualUse;
    }

    // show as fullName?
    toString(): string {
        return this.keyName.trim();
    }

    valueOf(): number {
        return this.id;
    }
}

export class KeyAssignment {
    key: Key;
    person: Person;
    boat?: Boat;
    id: number;
    keyNumber: string;
    keyFeePayed: boolean;
    keyFeePayedOn: Date;
    keyFeePayedBack: boolean;
    keyFeePayedBackOn: Date;
    fromDate: Date;
    toDate: Date;
    note: string;

    constructor(keyAssignment = {} as KeyAssignmentRaw) {
        this.id = keyAssignment.id || null;
        this.key = new Key(keyAssignment.key);
        this.person = keyAssignment.person ? new Person(keyAssignment.person) : null;
        this.boat = keyAssignment.boat ? new Boat(keyAssignment.boat) : null;
        this.keyNumber = keyAssignment.keyNumber || '';
        this.keyFeePayed = keyAssignment.keyFeePayed || false;
        this.keyFeePayedOn = tryParseDate(keyAssignment.keyFeePayedOn);
        this.keyFeePayedBack = keyAssignment.keyFeePayedBack || false;
        this.keyFeePayedBackOn = tryParseDate(keyAssignment.keyFeePayedBackOn);
        this.fromDate = tryParseDate(keyAssignment.fromDate);
        this.toDate = tryParseDate(keyAssignment.toDate);
        this.note = keyAssignment.note || '';
    }

    patch(keyAssignment = {} as KeyAssignment | KeyAssignmentRaw): void {
        Object
            .keys(keyAssignment)
            .forEach(key => {
                if (this.hasOwnProperty(key)) {
                    this[key] = keyAssignment[key];
                }
            });
    }

    // show as fullName?
    toString(): string {
        return this.keyNumber.trim();
    }

    valueOf(): number {
        return this.id;
    }

}
